
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNotifications } from './NotificationsContext';
import { getLocalStorage, setLocalStorage } from '../../../hooks/appVariables';

const NOTIFICATION_KEY = process.env.REACT_APP_SHOW_NOTIFICATION_KEY || 'showNotifications';

const ToastNotification = () => {
    const { lastNotification, removeNotification } = useNotifications();

    // On mount, ensure the notification key exists and is set to true if missing
    useEffect(() => {
        let existing;
        try {
            existing = window.localStorage.getItem(NOTIFICATION_KEY);
        } catch {
            existing = null;
        }
        if (existing === null) {
            setLocalStorage(NOTIFICATION_KEY, true);
        }
    }, []);

    useEffect(() => {
        if (!lastNotification?.ticketId) return;

        // Check notification preference from local storage
        let notificationsEnabled = true;
        try {
            notificationsEnabled = getLocalStorage(NOTIFICATION_KEY) !== false;
        } catch {
            notificationsEnabled = true;
        }
        if (!notificationsEnabled) return;

        const FormattedMessage = () => (
            <div style={{ 
                padding: '4px', 
                borderRadius: '8px'
            }}>
                <p style={{fontWeight: "bold"}}>{lastNotification.title}</p>
                {lastNotification.title === "Ticket Deleted" ? 
                    (<p>{lastNotification.message}</p>) : 
                    (
                        <p>{lastNotification.message}<br/><br/>
                            You can view the ticket&nbsp;
                            <a href={"/tickets/" + lastNotification.ticketId} style={{ color: '#007bff', textDecoration: 'underline' }}>here</a>
                        </p>
                    ) 
                }                
                {/* {lastNotification.person !== undefined ? (
                    <small>{"Currently owned by:" + lastNotification.person}</small>) 
                    : (<></>)
                } */}
            </div>
        );

        toast.success(<FormattedMessage />, {
            autoClose: 5000,
            progressClassName: "custom-progress-bar"
        });

        removeNotification(lastNotification.id);
    }, [lastNotification]);
};

export default ToastNotification